import React from 'react';
import VideoAnimation from '../animations/VideoAnimation';
import { InviteContent, InviteDarkMask } from './Common';
import { IUEvent } from '../../lib/event';
import TopModule from '../../pages/Event/TopModule';

const SeasonalInvite = ({ event }: { event: IUEvent }) => {
  return <>
    <InviteDarkMask/>
    <VideoAnimation url={event.backgroundAnimationUrl ?? ''}
                    asBackground={false}/>
    <InviteContent>
      <TopModule event={event} forSampleInvite={true} isAttending={true}/>
    </InviteContent>
  </>
}

export default SeasonalInvite;
